export function setCookie(cname, cvalue, exdays, htime) {
    let d = new Date();
    if (!htime) {
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    } else {
        d.setTime(d.getTime() + (exdays * 60 * 60 * 1000));
    }
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

export function get(name) {
    if (name = (new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)')).exec(location.search))
        return decodeURIComponent(name[1]);
}

export function insertParam(key, value) {
    key = encodeURI(key);
    value = encodeURI(value);

    let kvp = document.location.search.substr(1).split('&');

    let i = kvp.length;
    let x;
    while (i--) {
        x = kvp[i].split('=');

        if (x[0] == key) {
            x[1] = value;
            kvp[i] = x.join('=');
            break;
        }
    }

    if (i < 0) {
        kvp[kvp.length] = [key, value].join('=');
    }

    //this will reload the page, it's likely better to store this until finished
    document.location.search = kvp.join('&');
}

export function removeParam(key) {
    let sourceURL = window.location.href;
    let rtn = sourceURL.split("?")[0],
        param,
        params_arr = [],
        queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
    if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split("=")[0];
            if (param === key) {
                params_arr.splice(i, 1);
            }
        }
        rtn = rtn + "?" + params_arr.join("&");
    }
    document.location = rtn;
    return rtn;
}

export function magnify(imgID, zoom) {
    let img, glass, w, h, bw;
    img = document.getElementById(imgID);
    /*create magnifier glass:*/
    glass = document.createElement("DIV");
    glass.setAttribute("class", "img-magnifier-glass");
    /*insert magnifier glass:*/
    img.parentElement.insertBefore(glass, img);
    /*set background properties for the magnifier glass:*/
    glass.style.backgroundImage = "url('" + img.src + "')";
    glass.style.backgroundRepeat = "no-repeat";
    glass.style.backgroundSize = (img.width * zoom) + "px " + (img.height * zoom) + "px";
    bw = 3;
    w = glass.offsetWidth / 2;
    h = glass.offsetHeight / 2;
    /*execute a function when someone moves the magnifier glass over the image:*/
    glass.addEventListener("mousemove", moveMagnifier);
    img.addEventListener("mousemove", moveMagnifier);
    /*and also for touch screens:*/
    glass.addEventListener("touchmove", moveMagnifier);
    img.addEventListener("touchmove", moveMagnifier);

    function moveMagnifier(e) {
        let pos, x, y;
        /*prevent any other actions that may occur when moving over the image*/
        e.preventDefault();
        /*get the cursor's x and y positions:*/
        pos = getCursorPos(e);
        x = pos.x;
        y = pos.y;
        /*prevent the magnifier glass from being positioned outside the image:*/
        if (x > img.width - (w / zoom)) {
            x = img.width - (w / zoom);
        }
        if (x < w / zoom) {
            x = w / zoom;
        }
        if (y > img.height - (h / zoom)) {
            y = img.height - (h / zoom);
        }
        if (y < h / zoom) {
            y = h / zoom;
        }
        /*set the position of the magnifier glass:*/
        glass.style.left = (x - w) + "px";
        glass.style.top = (y - h) + "px";
        /*display what the magnifier glass "sees":*/
        glass.style.backgroundPosition = "-" + ((x * zoom) - w + bw) + "px -" + ((y * zoom) - h + bw) + "px";
    }

    function getCursorPos(e) {
        let a, x = 0, y = 0;
        e = e || window.event;
        /*get the x and y positions of the image:*/
        a = img.getBoundingClientRect();
        /*calculate the cursor's x and y coordinates, relative to the image:*/
        x = e.pageX - a.left;
        y = e.pageY - a.top;
        /*consider any page scrolling:*/
        x = x - window.pageXOffset;
        y = y - window.pageYOffset;
        return {x: x, y: y};
    }
}

export function arrayEdit(array, item, add) {
    if (add) {
        let exist = false;
        for (var KEY in array) {
            if (array[KEY] === item) {
                exist = true;
            }
        }
        if (!exist) {
            array[array.length] = item;
        }
    } else {
        for (var KEY in array) {
            if (array[KEY] === item) {
                array.splice(KEY, 1);
            }
        }
    }
    return array;
}

export function NegarshopCreateCustomAlert(txt) {
    let d = document;

    if (d.getElementById("negarshopAlertContainer")) return;

    let mObj = d.getElementsByTagName("body")[0].appendChild(d.createElement("div"));
    mObj.id = "negarshopAlertContainer";
    mObj.style.height = d.documentElement.scrollHeight + "px";

    let alertObj = mObj.appendChild(d.createElement("div"));
    alertObj.id = "negarshopAlertBox";
    if (d.all && !window.opera) alertObj.style.top = document.documentElement.scrollTop + "px";
    alertObj.style.left = (d.documentElement.scrollWidth - alertObj.offsetWidth) / 2 + "px";
    alertObj.style.visiblity = "visible";

    let h1 = alertObj.appendChild(d.createElement("h1"));
    h1.appendChild(d.createTextNode(NS_OBJ.i18n.message));

    let msg = alertObj.appendChild(d.createElement("p"));
    //msg.appendChild(d.createTextNode(txt));
    msg.innerHTML = txt;

    let btn = alertObj.appendChild(d.createElement("a"));
    btn.id = "closeBtn";
    btn.appendChild(d.createTextNode(NS_OBJ.i18n.ok));
    btn.href = "javascript:void(0)";
    btn.focus();
    btn.onclick = function () {
        NegarshopRemoveCustomAlert();
        return false;
    }

    alertObj.style.display = "block";

}

export function NegarshopRemoveCustomAlert() {
    document.getElementsByTagName("body")[0].removeChild(document.getElementById("negarshopAlertContainer"));
}

export function archive_btn(e) {
    let searchField = jQuery(e).parents('.search-form-widget').find('.search-input.search-field');
    searchField.val(decodeURI(encodeURI(searchField.val())));
    jQuery(e).parents('.search-form-widget').find('form').submit();
}

export function slideUp(target, duration = 250, callback = null) {
    if (target.dataset.sliding === 'true') return;
    target.dataset.sliding = 'true';
    
    const style = window.getComputedStyle(target);
    const originalHeight = target.offsetHeight;
    const originalPaddingTop = style.paddingTop;
    const originalPaddingBottom = style.paddingBottom;
    const originalMarginTop = style.marginTop;
    const originalMarginBottom = style.marginBottom;
    
    target.dataset.slideHeight = originalHeight;
    target.dataset.slidePaddingTop = originalPaddingTop;
    target.dataset.slidePaddingBottom = originalPaddingBottom;
    target.dataset.slideMarginTop = originalMarginTop;
    target.dataset.slideMarginBottom = originalMarginBottom;

    target.style.height = originalHeight + 'px';
    target.style.paddingTop = originalPaddingTop;
    target.style.paddingBottom = originalPaddingBottom;
    target.style.marginTop = originalMarginTop;
    target.style.marginBottom = originalMarginBottom;
    target.style.overflow = 'hidden';
    target.style.boxSizing = 'border-box';
    
    target.offsetHeight; // force reflow
    
    target.style.transition = `height ${duration}ms ease, padding ${duration}ms ease, margin ${duration}ms ease`;
    
    target.style.height = '0px';
    target.style.paddingTop = '0px';
    target.style.paddingBottom = '0px';
    target.style.marginTop = '0px';
    target.style.marginBottom = '0px';
    
    setTimeout(() => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition');
        target.style.removeProperty('box-sizing');
        target.dataset.sliding = 'false';
        if (typeof callback === 'function') {
            callback();
        }
    }, duration);
}

export function slideDown(target, duration = 250, callback = null) {
    if (target.dataset.sliding === 'true') return;
    target.dataset.sliding = 'true';
    
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;
    if (display === 'none') {
        display = 'block';
    }
    target.style.display = display;
    
    let targetHeight = target.dataset.slideHeight;
    let paddingTop = target.dataset.slidePaddingTop || '0px';
    let paddingBottom = target.dataset.slidePaddingBottom || '0px';
    let marginTop = target.dataset.slideMarginTop || '0px';
    let marginBottom = target.dataset.slideMarginBottom || '0px';
    
    if (!targetHeight) {
        const originalVisibility = target.style.visibility;
        const originalPosition = target.style.position;
        target.style.visibility = 'hidden';
        target.style.position = 'absolute';
        
        const style = window.getComputedStyle(target);
        targetHeight = target.offsetHeight;
        paddingTop = style.paddingTop;
        paddingBottom = style.paddingBottom;
        marginTop = style.marginTop;
        marginBottom = style.marginBottom;
        
        target.style.position = originalPosition;
        target.style.visibility = originalVisibility;
        
        target.dataset.slideHeight = targetHeight;
        target.dataset.slidePaddingTop = paddingTop;
        target.dataset.slidePaddingBottom = paddingBottom;
        target.dataset.slideMarginTop = marginTop;
        target.dataset.slideMarginBottom = marginBottom;
    }
    
    target.style.overflow = 'hidden';
    target.style.height = '0px';
    target.style.paddingTop = '0px';
    target.style.paddingBottom = '0px';
    target.style.marginTop = '0px';
    target.style.marginBottom = '0px';
    target.style.boxSizing = 'border-box';
    
    target.offsetHeight; // force reflow
    
    target.style.transition = `height ${duration}ms ease, padding ${duration}ms ease, margin ${duration}ms ease`;
    
    target.style.height = targetHeight + 'px';
    target.style.paddingTop = paddingTop;
    target.style.paddingBottom = paddingBottom;
    target.style.marginTop = marginTop;
    target.style.marginBottom = marginBottom;
    
    setTimeout(() => {
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition');
        target.style.removeProperty('box-sizing');
        target.dataset.sliding = 'false';
        if (typeof callback === 'function') {
            callback();
        }
    }, duration);
}
